import NavMenuGroup from './NavMenuGroup.vue';

export default NavMenuGroup;
